(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["box-landing"] && !Shopify.designMode) return;
  try {
    
/* Gentle, time-based falling in the viewport, independent of page scrolling. */
(() => {
  if (customElements.get('bc-landing')) return;
  class BCLanding extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-external-motion')) return;
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = !this.reduced.matches;
      this.sprinkles = this.dataset.sprinkles === 'true';
      this.hasMotion = this.sprinkles || Boolean(this.querySelector('.bc-ribbon--moving'));
      this.travel = 0;
      this.lastTime = null;
      this.frame = 0;
      this.canvas = document.createElement('canvas');
      this.canvas.className = 'bc-sprinkle-canvas';
      this.canvas.setAttribute('aria-hidden', 'true');
      this.canvas.id = `bc-sprinkles-${this.dataset.sectionId}`;
      this.ctx = this.canvas.getContext('2d');
      if (!this.ctx) { this.controller.abort(); this.controller = null; return; }
      this.toggle = document.createElement('button');
      this.toggle.type = 'button';
      this.toggle.className = 'bc-motion';
      this.toggle.setAttribute('aria-controls', this.canvas.id);
      this.toggle.setAttribute('aria-label', 'Toggle decorative motion');
      document.body.append(this.canvas, this.toggle);
      this.colors = ['--bc-pink', '--bc-aqua', '--bc-purple', '--bc-yellow'].map(c => getComputedStyle(this).getPropertyValue(c).trim());
      const count = Math.max(10, Math.min(60, Number(this.dataset.density) || 30));
      this.particles = Array.from({ length: count }, (_, i) => ({
        x: ((i * 0.6180339887 + 0.17) % 1),
        y: ((i * 0.4142135623 + 0.09) % 1),
        size: 6 + (i % 5),
        angle: i * 1.47,
        speed: 0.35 + (i % 7) * 0.075,
        color: this.colors[i % this.colors.length]
      }));
      this.updateButton();
      this.toggle.addEventListener('click', () => {
        this.enabled = !this.enabled;
        this.updateButton();
        this.schedule();
      }, { signal });
      this.reduced.addEventListener('change', () => {
        this.enabled = !this.reduced.matches;
        this.updateButton();
        this.schedule();
      }, { signal });
      window.addEventListener('resize', () => this.resize(), { passive: true, signal });
      document.addEventListener('visibilitychange', () => { this.updateButton(); this.schedule(); }, { signal });
      this.observer = new IntersectionObserver(([entry]) => {
        this.active = entry.isIntersecting;
        this.updateButton();
        this.schedule();
      });
      this.observer.observe(this);
      this.resize();
    }
    updateButton() {
      this.toggle.hidden = !this.active || this.reduced.matches || !this.hasMotion;
      this.toggle.textContent = this.enabled ? 'Pause motion' : 'Resume motion';
      this.toggle.setAttribute('aria-pressed', String(this.enabled));
      this.toggleAttribute('data-motion-paused', !this.enabled || !this.active || document.hidden);
    }
    resize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      this.canvas.width = Math.round(this.width * ratio);
      this.canvas.height = Math.round(this.height * ratio);
      this.ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      this.schedule();
    }
    schedule() {
      if (!this.frame) this.frame = requestAnimationFrame(time => { this.frame = 0; this.draw(time); });
    }
    draw(time) {
      this.ctx.clearRect(0, 0, this.width, this.height);
      if (!this.sprinkles || !this.active || !this.enabled || this.reduced.matches || document.hidden) {
        this.lastTime = null;
        return;
      }
      // Use elapsed time so the speed is consistent across screen refresh rates.
      // Cap elapsed time to prevent a jump when a background tab becomes visible.
      const elapsed = this.lastTime === null ? 0 : Math.min((time - this.lastTime) / 1000, 0.05);
      this.lastTime = time;
      this.travel += elapsed * 30 * (Number(this.dataset.fallSpeed) || 2);
      const rect = this.getBoundingClientRect();
      const top = Math.max(0, rect.top), bottom = Math.min(this.height, rect.bottom);
      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.rect(0, top, this.width, Math.max(0, bottom - top));
      this.ctx.clip();
      const count = this.width < 700 ? Math.ceil(this.particles.length * 0.6) : this.particles.length;
      this.particles.slice(0, count).forEach(p => {
        const y = ((p.y * (this.height + 40) + this.travel * p.speed) % (this.height + 40)) - 20;
        // Keep most sprinkles near the edges so body text remains easy to read.
        const lane = p.x < 0.5 ? p.x * 0.38 : 0.81 + (p.x - 0.5) * 0.38;
        const x = lane * this.width + Math.sin(this.travel * 0.002 + p.angle) * 18;
        this.ctx.save();
        this.ctx.translate(x, y);
        this.ctx.rotate(p.angle + this.travel * 0.002);
        this.ctx.globalAlpha = 0.78;
        this.ctx.strokeStyle = p.color;
        this.ctx.lineWidth = 4;
        this.ctx.lineCap = 'round';
        this.ctx.beginPath();
        this.ctx.moveTo(-p.size / 2, 0);
        this.ctx.lineTo(p.size / 2, 0);
        this.ctx.stroke();
        this.ctx.restore();
      });
      this.ctx.restore();
      this.schedule();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.lastTime = null;
      this.canvas?.remove();
      this.toggle?.remove();
      this.controller = null;
    }
  }
  customElements.define('bc-landing', BCLanding);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
